
function load_shippings(list = false) {
    let shipping = $('.bp-shop-cart-section .address-container');
    let shipping_options_list = shipping.find('.shipping-options');
    let shipping_options = shipping_options_list.find('.bp-input-label .bp-input');
    let page_total_value = $('.bp-shop-cart-section .cart-total .total');

    let cart_description = $('.bp-shop-cart-section .cart-description');

    if(list){
        shipping_options_list_html = "";
    
        list.forEach( function(element, index) {
            let selected = '';
            let checked = '';
            if(element.selected){
                selected = ' selected ';
                checked = ' checked="" ';
            }
    
            shipping_options_list_html += '<label class="bp-input-label -checkbox '+selected+'" >'
                                        +'<input class="bp-input" name="shipping-option" type="radio" '+checked+' value="'+element.id+'" data-total-value="'+element.total_value_formated+'">'
                                        // +'<span><b class="-green">'+element.value_formated+'</b> - '+element.name+' '+element.address+' '+element.description+'</span>'
                                        +'<span><b class="-green">'+element.value_formated+'</b> - '+element.name+' '+element.address+'</span>'
                                    +'</label>';
        });
        shipping_options_list.html(shipping_options_list_html);
    
        shipping_options = shipping_options_list.find('.bp-input-label .bp-input');
    
    }

    shipping_options.each(function(index, shipping_option) {
        if(shipping_option.checked){
            $(shipping_option).parents('.bp-input-label.-checkbox').addClass('selected');
        }else{
            $(shipping_option).parents('.bp-input-label.-checkbox').removeClass('selected');
        }

    });

    shipping_options.change(function(event) {
        shipping_options.each(function(index, shipping_option) {
            if(shipping_option.checked){
                $(shipping_option).parents('.bp-input-label.-checkbox').addClass('selected');
            }else{
                $(shipping_option).parents('.bp-input-label.-checkbox').removeClass('selected');
            }

        });

        if(this.checked){
            page_total_value.html($(this).data('total-value'));
        

            shipping.addClass('loading');

            let dados_envio = {
                'nonce': js_global.cart_shipping_nonce,
                'action': 'cart_select_shipping',
                'shipping': parseInt(this.value),
            }


            $.ajax({
                url: js_global.xhr_url,
                type: 'POST',
                data: dados_envio,
                dataType: 'JSON',
                beforeSend: function(){
                    
                },
                complete: function(){
                    shipping.removeClass('loading');
                },
                error: function(erro){
                    // console.log(erro);
                    // alert('Erro!');
                    alert('Erro de comunicação com o servidor');
                },
                success: function(response) {
                    // console.log('success');
                    // response = JSON.parse(response);
                    // console.log(response);

                    if(response.error){
                    
                        load_shippings(response.shipping_list);

                    }else if(response.success){

                        if(response.redirect && response.redirect == true){
                            location.href = response.redirect_url;
                        }else{
                            
                            let description_json = JSON.parse(cart_description.val());

                            load_shippings(response.shipping_list);
                            
                            description_json.shipping = null;
                            
                            response.shipping_list.forEach(function(el){
                                if(el.selected){
                                    description_json.shipping = el.id;
                                }
                            });

                            cart_description.val(JSON.stringify(description_json));
                        }

                        
                    }else{
                        load_shippings(response.shipping_list);
                    }

                }
            });
        }
    });
}



// Generate the card template
function startCardTemplate(){

    $('#bp-checkout-form #bp-checkout-card-data').each(function(index, el) {

        let container = $(el);
        let form = container.parents('#bp-checkout-form');
        let card_wrapper = container.find('.card-wrapper');

        let checkout_recaptcha = container.find('.bp-g-recaptcha-t');

        let clearsale_session_id = container.find('.bp-clearsale-session-id');

        let buy_modal = $('.bp-buy-modal-infos');
        let buy_modal_content = buy_modal.find('.content');

        let buy_card_submit = container.find('.btn-card-submit');
        let order_id = container.find('#order-id');
        let order_value = container.find('#order-value');
        let order_checkout_nonce_submit = container.find('#order-checkout-nonce-submit');


        let card_inputs = container.find('input#card-number, input#card-fullname, input#card-expiry, select#card-expiry-month, select#card-expiry-year, input#card-cvv, select#card-flag, select#payment-method');

        let card_number = container.find('input#card-number');
        let card_name = container.find('input#card-fullname');
        let card_month = container.find('select#card-expiry-month');
        let card_cvv = container.find('input#card-cvv');
        let card_flag = container.find('select#card-flag');
        let card_year = container.find('select#card-expiry-year');
        let card_expiry = container.find('input#card-expiry');
        let card_method = container.find('select#payment-method');
        let card_installments = container.find('select#payment-installments');

        let billing_inputs = form.find('input#billing-first-name, input#billing-last-name, input#billing-email, input#billing-document, input#billing-phone, input#billing-birthdate, select#billing-sex');

        let billing_first_name = form.find('input#billing-first-name');
        let billing_last_name = form.find('input#billing-last-name');
        let billing_email = form.find('input#billing-email');
        let billing_document = form.find('input#billing-document');
        let billing_phone = form.find('input#billing-phone');
        let billing_birthdate = form.find('input#billing-birthdate');
        let billing_sex = form.find('select#billing-sex');




        checkoutCard = new Card({
            form: form[0],
            container: card_wrapper[0],
            formSelectors: {
                numberInput: 'input#card-number',
                expiryInput: 'input#card-expiry',
                cvcInput: 'input#card-cvv',
                nameInput: 'input#card-fullname'
            },
            messages: {
                validDate: '',
                monthYear: 'Válido até',
            },
            placeholders: {
                number: '•••• •••• •••• ••••',
                name: 'NOME NO CARTAO',
                expiry: '••/••••',
                cvc: '•••'
            }
        });



        card_month.add(card_year).change(function(event) {
            card_expiry.val(card_month[0].value+' / '+card_year[0].value);
            
            card_expiry[0].dispatchEvent(new Event('change'));
            card_expiry.change();
            card_expiry.keypress();
        });

        if(card_installments.length > 0){
            card_method.change(function(event) {
                if(card_method.val() == card_method.data('credit')){
                    card_installments.removeClass('hidde');
                    card_installments.parent('.bp-input-label').removeClass('hidde');
                }else{
                    card_installments.addClass('hidde');
                    card_installments.parent('.bp-input-label').addClass('hidde');
                }
            });
        }

        card_method.change();


        card_inputs.add(billing_inputs).change(function(event) {
            check_inputs_card(el);
        });
        
        card_inputs.add(billing_inputs).keyup(function(event) {
            check_inputs_card(el);
        });

        form.submit(function(event) {
            event.preventDefault();
            buy_card_submit[0].disabled = true;

            setTimeout(function(){
                $(form.find('.bp-form-error')[0]).focus();
            },500);


            let input_erro = false;
            card_inputs.add(billing_inputs).each(function(index, input) {
                if(input.value == ''){
                    input_erro = true;
                }
            });

            if(!input_erro){

                let selected_installments = 1;

                if(card_installments.length > 0){
                    selected_installments = card_installments.val();
                }

                let dados_envio = {
                    'nonce_page': js_global.buy_page_nonce,
                    'nonce_submit': order_checkout_nonce_submit.val(),
                    'action': 'order_checkout_submit',
                    'order': order_id.val(),
                    'order_value': order_value.val(),
                    'recaptcha': checkout_recaptcha.val(),
                    'clearsale_session_id': clearsale_session_id.val(),

                    'data' : {
                                card_number: card_number.val(),
                                card_name: card_name.val(),
                                card_expiry: card_expiry.val(),
                                card_expiry_month: card_month.val(),
                                card_expiry_year: card_year.val(),
                                card_cvv: card_cvv.val(),
                                card_flag: card_flag.val(),
                                card_method: card_method.val(),
                                card_installments: selected_installments,

                                billing_first_name: billing_first_name.val(),
                                billing_last_name: billing_last_name.val(),
                                billing_email: billing_email.val(),
                                billing_document: billing_document.val(),
                                billing_phone: billing_phone.val(),
                                billing_birthdate: billing_birthdate.val(),
                                billing_sex: billing_sex.val(),
                            }
                        ,
                }

                $.ajax({
                    url: js_global.xhr_url,
                    type: 'POST',
                    data: dados_envio,
                    dataType: 'JSON',
                    beforeSend: function(){
                        buy_modal.addClass('active');
                        buy_modal_content.html('<div class="load"><img src="'+buy_modal.data('load-img')+'"><p>Carregando</p></div>');
                    },
                    complete: function(){
                        buy_card_submit[0].disabled = false;
                        grecaptcha.execute(wpcf7_recaptcha.sitekey, {action: 'submit'}).then(function(token) {
                            var i = $('input.bp-g-recaptcha-t');
                            i.val(token);
                        });
                    },
                    error: function(erro){
                        // console.log(erro);
                        // alert('Erro!');
                        
                        buy_modal_content.html('<div class="error"><span></span><p>Erro de comunicação com o servidor</p><button class="btn" type="button">Tentar novamente</button></div>');
                        buy_modal_content.find('button').click(function(event) {
                            buy_modal.removeClass('active');
                            card_number.val('');
                            card_name.val('');
                            card_expiry.val('');
                            card_month.val('');
                            card_year.val('');
                            card_cvv.val('');
                            card_flag.val('');
                        });
                        // message.html('<p>Erro de comunicação com o servidor</p>');
                        // message.removeClass('loading');
                        // message.removeClass('success');
                        // message.addClass('error');
                    },
                    success: function(response) {
                        // console.log('success');
                        // response = JSON.parse(response);
                        // console.log(response);

                        if(response.error){
                        
                            if(response.error == "outdated_value"){
                                buy_modal_content.html('<div class="error"><span></span><p>Os dados do pedido estão desatualizados, recarregue a pagina e tente novamente.</p></div>');
                            
                            }else if(response.error == "billing_address_invalid"){
                                buy_modal_content.html('<div class="error"><span></span><p>Selecione um endereço de cobrança válido.</p><button class="btn" type="button">Tentar novamente</button></div>');
                                

                            }else if(response.error == "erede_payment_error"){
                                buy_modal_content.html('<div class="error"><span></span><p>Erro ao realizar o pagamento.</p><button class="btn" type="button">Tentar novamente</button></div>');

                            }else if(response.error == "invalid_document"){
                                buy_modal_content.html('<div class="error"><span></span><p>CPF/CNPJ inválido.</p><button class="btn" type="button">Tentar novamente</button></div>');

                            }else if(response.error == "clearsale_error"){
                                buy_modal_content.html('<div class="error"><span></span><p>Erro na análise de dados, se o problema persistir entre em contato com nossa equipe!</p><a href="'+response.redirect_url+'" class="btn" >Continuar</a></div>');

                            }else if(response.error == "clearsale_not_approved"){
                                buy_modal_content.html('<div class="error"><span></span><p>A compra não foi aprovada pela análise de dados, se o problema persistir entre em contato com nossa equipe!</p><a href="'+response.redirect_url+'" class="btn" >Continuar</a></div>');

                            }else if(response.error == "invalid_data"){
                                buy_modal_content.html('<div class="error"><span></span><p>Dados incorretos, recarregue a pagina e tente novamente.</p><a href="'+response.redirect_url+'" class="btn" >Continuar</a></div>');
                            }else if(response.error == "need_policy_and_terms"){
                                buy_modal_content.html('<div class="error"><span></span><p>'+response.error_text+' </p><button class="btn" type="button">Tentar novamente</button></div>');
                            }

                            buy_modal_content.find('button').click(function(event) {
                                buy_modal.removeClass('active');
                                card_number.val('');
                                card_name.val('');
                                card_expiry.val('');
                                card_month.val('');
                                card_year.val('');
                                card_cvv.val('');
                                card_flag.val('');
                            });

                            // message.removeClass('loading');
                            // message.removeClass('success');
                            // message.addClass('error');

                        }else if(response.success){


                            if(response.payment_success && response.payment_success == true){
                                if(response.dataLayerArgs){
                                    dataLayer.push(response.dataLayerArgs);
                                }
                            }

                            if(response.redirect && response.redirect == true){
                                location.href=response.redirect_url;
                            }else{


                                // message.html('<p>Produto adicionado ao carrinho!</p><p><b><a href="'+js_global.cart_page_url+'">Finalizar compra</a></b></p>');
                                // message.removeClass('error');
                                // message.removeClass('loading');
                                // message.addClass('success');
                            }

                            if(response.clearsale_sent_for_analysis && response.clearsale_sent_for_analysis == true){
                                buy_modal_content.html('<div class="success"><span><span></span></span><p>Os dados da compra foram enviados para análise!</p><a href="'+response.redirect_url+'" class="btn" >Continuar</a></div></div>');
                            }else{
                                buy_modal_content.html('<div class="success"><span><span></span></span><p>Pagamento realizado com sucesso.</p><a href="'+response.redirect_url+'" class="btn" >Continuar</a></div></div>');
                            }


                            
                            
                        }else{
                            // message.html('<p>Ocorreu um erro</p><p>Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');
                            // message.removeClass('loading');
                            // message.removeClass('success');
                            // message.addClass('error');
                        }

                    }
                });
            }


        });

    });

}

function check_inputs_card(el){
    let card_inputs = $(el).find('input#card-number, input#card-fullname, input#card-expiry, select#card-expiry-month, select#card-expiry-year, input#card-cvv, select#card-flag, select#payment-method');

    let number = $(el).find('input#card-number');
    let fullname = $(el).find('input#card-fullname');
    let month = $(el).find('select#card-expiry-month');
    let year = $(el).find('select#card-expiry-year');
    let expiry = $(el).find('input#card-expiry');
    let method = $(el).find('select#payment-method');
    let cvv = $(el).find('input#card-cvv');
    let flag = $(el).find('select#card-flag');
    let installments = $(el).find('select#payment-installments');

    let buy_card_submit = $(el).find('.btn-card-submit');


    if(    number.val() && number.val() != ""
        && fullname.val() && fullname.val() != ""
        && month.val() && month.val() != ""
        && year.val() && year.val() != ""
        && expiry.val() && expiry.val() != ""
        && method.val() && method.val() != ""
        && cvv.val() && cvv.val() != ""
        && flag.val() && flag.val() != ""
        ){
        buy_card_submit[0].disabled = false;
    }else{
        
        buy_card_submit[0].disabled = true;
    }
}

(function($, window, document) {


    startCardTemplate();


    $('.dish-buy').each(function(index, el) {
        let container = $(el);
        let buy = $(container).find('.buy');
        let select = $(container).find('.select select');
        let input = $(container).find('.input-num input');
        let message = $(container).find('.buy-message');
        let qtd = $(container).find('.buy-product-qtd');


        select.change(function(event) {
            let id = this.value;
            let option = $(this).find('option:selected');
            let temp_html = '';

            input.val(1);

            input.parents('.input-num')[0].min = 1;
            input[0].min = 1;
            input.parents('.input-num')[0].max = option.data('max');
            input[0].max = option.data('max');

            if(select.data('type') == 'variable'){
                temp_html = 'Sem estoque';
            
                if(parseInt(option.data('max')) == 1){
                    temp_html = '1 disponível';
                }else if(parseInt(option.data('max')) > 1){
                    temp_html = parseInt(option.data('max'))+' disponíveis';
                }
                    
                qtd.html(temp_html);
            }else{
                qtd.html('');
            }

            input.data('id', id);
            input.data('price', option.data('price'));
        });
        select.click(function(event) {
            if(this.value && this.value != ''){
                $(this).change();
            }
        });
        if(select.val() && select.val() != ''){
            select.change();
        }

        buy.click(function(event) {
            buy.attr('disabled',true);
            message.html('<p>Adicionando ao carrinho</p>');
            message.addClass('loading');

            if(input.val() > 0 && input.data('id') && input.data('id') > 0){


                let dados_envio = {
                    'nonce': js_global.cart_add_product_nonce,
                    'action': 'cart_add_product',
                    'product': input.data('id'),
                    'product_price': input.data('price'),
                    'qtd': input.val(),
                }

                $.ajax({
                    url: js_global.xhr_url,
                    type: 'POST',
                    data: dados_envio,
                    dataType: 'JSON',
                    beforeSend: function(){
                        
                    },
                    complete: function(){
                        buy.attr('disabled',false);
                    },
                    error: function(erro){
                        // console.log(erro);
                        // alert('Erro!');
                        message.html('<p>Erro de comunicação com o servidor</p>');
                        message.removeClass('loading');
                        message.removeClass('success');
                        message.addClass('error');
                    },
                    success: function(response) {
                        // console.log('success');
                        // response = JSON.parse(response);
                        // console.log(response);

                        if(response.error){
                        
                            if(response.error == "need_reload"){
                                message.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                            }else if(response.error == "has_no_stock"){
                                if(response.has_in_cart){
                                    let available_label = ' items disponíveis ';
                                    if(response.available == 1){
                                        available_label = ' item disponível ';
                                    }

                                    message.html('<p>Temos '+response.available+' '+available_label+', você já possui '+response.qtd_in_cart+' no seu carrinho e tentou adicionar mais '+response.requested+'.</p>');

                                }else{
                                    message.html('<p>Sem estoque suficiente</p>');

                                }

                            }else if(response.error == "many_selected"){
                                message.html('<p>Muitos itens selecionados</p>');

                            }else if(response.error == "invalid_data"){
                                message.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                            }else if(response.error == "error_adding_package"){
                                message.html('<p>Ocorreu um erro</p><p>Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');

                            }
                            message.removeClass('loading');
                            message.removeClass('success');
                            message.addClass('error');

                        }else if(response.success){

                            if(response.redirect && response.redirect == true){
                                location.href=response.redirect_url;
                            }else{

                                if(response.cart_qtd || response.cart_qtd === 0){
                                    if(response.cart_qtd > 0){
                                        $('.bp-header-section .bp-header-shop-link .cart-icon').html('<span class="cart-qtd">'+response.cart_qtd+"</span>");
                                    }else{
                                        $('.bp-header-section .bp-header-shop-link .cart-icon').html("");
                                    }

                                }


                                message.html('<p>Produto adicionado ao carrinho!</p><p><b><a href="'+js_global.cart_page_url+'">Finalizar compra</a></b></p>');
                                message.removeClass('error');
                                message.removeClass('loading');
                                message.addClass('success');
                            }

                            // console.log(response.dataLayerArgs);
                            // if(response.dataLayerArgs){
                            //     dataLayer.push(response.dataLayerArgs);
                            // }
                            
                        }else{
                            message.html('<p>Ocorreu um erro</p><p>Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');
                            message.removeClass('loading');
                            message.removeClass('success');
                            message.addClass('error');
                        }

                    }
                });


            }else{
                if(!(input.data('id') && input.data('id') > 0)){
                    message.html('<p>Selecione uma das opções do produto antes de adicioná-lo ao carrinho</p>');
                    message.removeClass('loading');
                    message.removeClass('success');
                    message.addClass('error');
                }else if(input.val() < 1){
                    message.html('<p>A quantidade deve ser superiora a 0</p>');
                    message.removeClass('loading');
                    message.removeClass('success');
                    message.addClass('error');
                }
                
                buy.attr('disabled',false);
            }

        });
    });


    


    


    $('.bp-shop-cart-table').each(function(table_index, table_el) {
        let table = $(table_el);
        let message = table.find('tr.message');
        let message_text = table.find('tr.message .text');
        let total_label = table.find('tr.total .label');
        let total_value = table.find('tr.total .value');
        let page_total_value = $('.bp-shop-cart-section .cart-total .total');

        let cart_description = $('.bp-shop-cart-section .cart-description');

        let remove_coupon_btn = table.find('.remove-coupon-btn');
        let coupon = table.find('tr.coupon');
        let coupon_name = coupon.find('.label');
        let coupon_value = coupon.find('.value');

        message.data('time', -1);
        setInterval(function(){
            let current_time = message.data('time');
            if(current_time == 0){
                message.data('time', -1);
                message.removeClass('active');
                message.removeClass('loading');
                message.removeClass('error');
            }else if (current_time > 0) {
                message.data('time',current_time - 1);
            }
        }, 1000);

        table.find('tbody tr[data-id]').each(function(item_index, item_el) {
            let item = $(item_el);

            if(item.data('id') && item.data('id') > 0){

                let name = item.find('.item .description').html();
                let remove_btn = item.find('.remove-item-btn');
                let input_qtd = item.find('.qtd .input-num input');
                let subtotal_value  = item.find('.price .price');


                remove_btn.click(function(event) {

                    if(remove_btn.hasClass('loading')){

                    }else{

                        remove_btn.addClass('loading');
                        message_text.html('<p>Removendo produto: '+name+'</p>');
                        message.addClass('loading');

                        let dados_envio = {
                            'nonce': js_global.cart_remove_product_nonce,
                            'action': 'cart_remove_product',
                            'product': item.data('id'),
                        }

                        $.ajax({
                            url: js_global.xhr_url,
                            type: 'POST',
                            data: dados_envio,
                            dataType: 'JSON',
                            beforeSend: function(){
                                
                            },
                            complete: function(){
                                remove_btn.removeClass('loading');
                                message.removeClass('loading');

                                message.data('time', 10);
                            },
                            error: function(erro){
                                // console.log(erro);
                                // alert('Erro!');
                                message_text.html('<p>Erro de comunicação com o servidor</p>')
                                message.removeClass('active');
                                message.removeClass('loading');
                                message.addClass('error');
                                
                            },
                            success: function(response) {
                                // console.log('success');
                                // response = JSON.parse(response);
                                // console.log(response);

                                if(response.error){
                                
                                    if(response.error == "need_reload"){
                                        message_text.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                                    }else if(response.error == "invalid_data"){
                                        message_text.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                                    }else if(response.error == "not_found"){
                                        message_text.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                                    }else if(response.error == "error_adding_package"){
                                        message_text.html('<p>Ocorreu um erro</p><p>Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');

                                    }
                                    message.removeClass('active');
                                    message.removeClass('loading');
                                    message.addClass('error');
                                    

                                }else if(response.success){

                                    if(response.redirect && response.redirect == true){
                                        location.href=response.redirect_url;
                                    }else{

                                        let description_json = JSON.parse(cart_description.val());


                                        if(response.remove_id){
                                            table.find('tbody tr[data-id="'+response.remove_id+'"]').remove();

                                            total_value.html(response.cart_value_formated);
                                            page_total_value.html(response.cart_value_formated);

                                            $('.bp-shop-cart-container>.title span').html("("+response.cart_qtd+")");
                                            if(response.cart_qtd || response.cart_qtd === 0){
                                                if(response.cart_qtd > 0){
                                                    $('.bp-header-section .bp-header-shop-link .cart-icon').html('<span class="cart-qtd">'+response.cart_qtd+"</span>");
                                                }else{
                                                    $('.bp-header-section .bp-header-shop-link .cart-icon').html("");
                                                }
                                            }

                                            let temp_products = [];
                                            for (let i = 0; i < description_json.products.length; i++) {
                                                if(description_json.products[i].product_id != response.remove_id){
                                                    temp_products.push( description_json.products[i]);
                                                }
                                            }
                                            description_json.products = temp_products;

                                        }

                                        message_text.html('<p>Produto "'+name+'" removido do carrinho!</p>');
                                        message.removeClass('error');
                                        message.removeClass('loading');
                                        message.addClass('active');

                                        load_shippings(response.shipping_list);

                                        if(response.coupon_id && response.coupon_id > 0){
                                            coupon.addClass('active');
                                            coupon_name.html('<b>Cupom:</b> '+response.coupon_name);
                                            coupon_value.html(response.coupon_value_formated);
                                            description_json.coupon = response.coupon_id;
                                        }else{
                                            coupon.removeClass('active');
                                            coupon_name.html('');
                                            coupon_value.html('');
                                            description_json.coupon = null;
                                        }

                                        cart_description.val(JSON.stringify(description_json));
                                    }

                                    // console.log(response.dataLayerArgs);
                                    // if(response.dataLayerArgs){
                                    //     dataLayer.push(response.dataLayerArgs);
                                    // }
                                    
                                }else{
                                    message_text.html('<p>Ocorreu um erro</p><p>Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');
                                    message.removeClass('active');
                                    message.removeClass('loading');
                                    message.addClass('error');
                                    
                                }

                            }
                        });

                    }


                });


                input_qtd.change(function(event) {
                    message_text.html('<p>Atualizando quantidade do produto: '+name+'</p>');
                    message.addClass('loading');

                    let dados_envio = {
                        'nonce': js_global.cart_change_product_nonce,
                        'action': 'cart_change_product_qtd',
                        'product': item.data('id'),
                        'product_qtd': input_qtd.val(),
                    }

                    $.ajax({
                        url: js_global.xhr_url,
                        type: 'POST',
                        data: dados_envio,
                        dataType: 'JSON',
                        beforeSend: function(){
                            
                        },
                        complete: function(){
                            message.removeClass('loading');

                            message.data('time', 10);
                        },
                        error: function(erro){
                            // console.log(erro);
                            // alert('Erro!');
                            message_text.html('<p>Erro de comunicação com o servidor</p>')
                            message.removeClass('active');
                            message.removeClass('loading');
                            message.addClass('error');
                            
                        },
                        success: function(response) {
                            // console.log('success');
                            // response = JSON.parse(response);
                            // console.log(response);

                            if(response.error){
                            
                                if(response.error == "need_reload"){
                                    message_text.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                                }else if(response.error == "has_no_stock"){
                                    message_text.html('<p>Sem estoque suficiente</p>');

                                }else if(response.error == "many_selected"){
                                    message_text.html('<p>Muitos itens selecionados</p>');

                                }else if(response.error == "invalid_data"){
                                    message_text.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                                }else if(response.error == "not_found"){
                                    message_text.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                                }else if(response.error == "error_adding_package"){
                                    message_text.html('<p>Ocorreu um erro</p><p>Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');
                                }

                                if(response.default_qtd || response.default_qtd === 0){
                                    input_qtd.val(response.default_qtd);
                                }


                                message.removeClass('active');
                                message.removeClass('loading');
                                message.addClass('error');
                                

                            }else if(response.success){

                                if(response.redirect && response.redirect == true){
                                    location.href=response.redirect_url;
                                }else{

                                    let description_json = JSON.parse(cart_description.val());

                                    // input_qtd.val(response.product_qtd);
                                    
                                    if( response.not_available ){
                                        item.addClass(' not-available ');
                                    }else{
                                        item.removeClass(' not-available ');
                                    }

                                    
                                    for (let i = 0; i < description_json.products.length; i++) {
                                        if(description_json.products[i].product_id == response.product_id){
                                            description_json.products[i].qtd = response.product_qtd;
                                        }
                                    }

                                    
                                    $('.bp-shop-cart-container>.title span').html("("+response.cart_qtd+")");
                                    if(response.cart_qtd || response.cart_qtd === 0){
                                        if(response.cart_qtd > 0){
                                            $('.bp-header-section .bp-header-shop-link .cart-icon').html('<span class="cart-qtd">'+response.cart_qtd+"</span>");
                                        }else{
                                            $('.bp-header-section .bp-header-shop-link .cart-icon').html("");
                                        }
                                    }


                                    subtotal_value.html(response.product_subtotal_formated);
                                    total_value.html(response.cart_value_formated);
                                    page_total_value.html(response.cart_value_formated);
                                    
                                    message_text.html('<p>Produto "'+name+'" atualizado!</p>');
                                    message.removeClass('error');
                                    message.removeClass('loading');
                                    message.addClass('active');

                                    load_shippings(response.shipping_list);

                                    if(response.coupon_id && response.coupon_id > 0){
                                        coupon.addClass('active');
                                        coupon_name.html('<b>Cupom:</b> '+response.coupon_name);
                                        coupon_value.html(response.coupon_value_formated);
                                        description_json.coupon = response.coupon_id;
                                    }else{
                                        coupon.removeClass('active');
                                        coupon_name.html('');
                                        coupon_value.html('');
                                        description_json.coupon = null;
                                    }

                                    cart_description.val(JSON.stringify(description_json));
                                }

                                // console.log(response.dataLayerArgs);
                                // if(response.dataLayerArgs){
                                //     dataLayer.push(response.dataLayerArgs);
                                // }
                                
                            }else{
                                message_text.html('<p>Ocorreu um erro</p><p>Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');
                                message.removeClass('active');
                                message.removeClass('loading');
                                message.addClass('error');
                                
                            }

                        }
                    });
                });
            }
        });



        remove_coupon_btn.click(function(event) {

            if(remove_coupon_btn.hasClass('loading')){

            }else{

                remove_coupon_btn.addClass('loading');
                message_text.html('<p>Removendo cupom</p>');
                message.addClass('loading');

                let dados_envio = {
                    'nonce': js_global.cart_remove_product_nonce,
                    'action': 'cart_remove_coupon',
                }

                $.ajax({
                    url: js_global.xhr_url,
                    type: 'POST',
                    data: dados_envio,
                    dataType: 'JSON',
                    beforeSend: function(){
                        
                    },
                    complete: function(){
                        remove_coupon_btn.removeClass('loading');
                        message.removeClass('loading');

                        message.data('time', 10);
                    },
                    error: function(erro){
                        // console.log(erro);
                        // alert('Erro!');
                        message_text.html('<p>Erro de comunicação com o servidor</p>')
                        message.removeClass('active');
                        message.removeClass('loading');
                        message.addClass('error');
                        
                    },
                    success: function(response) {
                        // console.log('success');
                        // response = JSON.parse(response);
                        // console.log(response);

                        if(response.error){
                        
                            if(response.error == "need_reload"){
                                message_text.html('<p>Ocorreu um erro</p><p>Recarregue a pagina e tente novamente</p>');

                            }
                            message.removeClass('active');
                            message.removeClass('loading');
                            message.addClass('error');
                            

                        }else if(response.success){

                            if(response.redirect && response.redirect == true){
                                location.href=response.redirect_url;
                            }else{

                                let description_json = JSON.parse(cart_description.val());

                                coupon.removeClass('active');
                                description_json.coupon = null;

                                total_value.html(response.cart_value_formated);
                                page_total_value.html(response.cart_value_formated);

                                // $('.bp-shop-cart-container>.title span').html("("+response.cart_qtd+")");
                                // if(response.cart_qtd || response.cart_qtd === 0){
                                //     if(response.cart_qtd > 0){
                                //         $('.bp-header-section .bp-header-shop-link .cart-icon').html('<span class="cart-qtd">'+response.cart_qtd+"</span>");
                                //     }else{
                                //         $('.bp-header-section .bp-header-shop-link .cart-icon').html("");
                                //     }

                                // }
                                
                                message_text.html('<p>Cupom removido do carrinho!</p>');
                                message.removeClass('error');
                                message.removeClass('loading');
                                message.addClass('active');

                                load_shippings(response.shipping_list);

                                cart_description.val(JSON.stringify(description_json));
                            }

                            // console.log(response.dataLayerArgs);
                            // if(response.dataLayerArgs){
                            //     dataLayer.push(response.dataLayerArgs);
                            // }
                            
                        }else{
                            message_text.html('<p>Ocorreu um erro</p><p>Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');
                            message.removeClass('active');
                            message.removeClass('loading');
                            message.addClass('error');
                            
                        }

                    }
                });

            }


        });
    });



    $('.input-add-coupon').each(function(index, el) {
        let add_coupon_container = $(el);
        let add_coupon_input = add_coupon_container.find('input');
        let add_coupon_btn = add_coupon_container.find('button');
        let add_coupon_error = add_coupon_container.find('.bp-error');
        let coupon = $('.bp-shop-cart-table tr.coupon');
        let coupon_name = coupon.find('.label');
        let coupon_value = coupon.find('.value');
        let gift_card = $('.bp-shop-cart-table tr.gift-card');
        let gift_card_name = gift_card.find('.label');
        let gift_card_value = gift_card.find('.value');
        let total_value = $('.bp-shop-cart-table .total .value')
        let page_total_value = $('.bp-shop-cart-section .cart-total .total');

        let cart_description = $('.bp-shop-cart-section .cart-description');

        let cart_message = $('.bp-shop-cart-table tr.message');
        let cart_message_text = $('.bp-shop-cart-table tr.message .text');


        add_coupon_input.change(function(event) {
            this.value = this.value.toUpperCase();
        });
        add_coupon_input.keyup(function(event) {
            if(this.value != this.value.toUpperCase()){
                let start = event.target.selectionStart;
                this.value = this.value.toUpperCase();
                this.setSelectionRange(start,start);
            }
        });

        

        add_coupon_btn.click(function(event) {
            if(add_coupon_input.val() == ''){
                add_coupon_container.addClass('bp-form-error');
                add_coupon_error.html('Adicione o código no campo a cima');
                return;
            }

            add_coupon_btn.attr('disabled',true);
            cart_message_text.html('<p>Verificando cupom</p>');
            cart_message.addClass('loading');

            let dados_envio = {
                'nonce': js_global.cart_add_product_nonce,
                'action': 'cart_add_coupon',
                'coupon': add_coupon_input.val(),
            }

            $.ajax({
                url: js_global.xhr_url,
                type: 'POST',
                data: dados_envio,
                dataType: 'JSON',
                beforeSend: function(){
                    
                },
                complete: function(){
                    add_coupon_btn.attr('disabled',false);
                    cart_message.removeClass('loading');

                    // cart_message.data('time', 10);

                },
                error: function(erro){
                    // console.log(erro);
                    // alert('Erro!');
                    add_coupon_container.addClass('bp-form-error');
                    add_coupon_error.html('Erro de comunicação com o servidor');

                    cart_message.data('time', 0);
                    cart_message.removeClass('error');
                    cart_message.removeClass('loading');
                    cart_message.removeClass('active');
                    
                },
                success: function(response) {
                    // console.log('success');
                    // response = JSON.parse(response);
                    // console.log(response);

                    if(response.error){
                    
                        if(response.error == "need_reload"){
                            add_coupon_error.html('Ocorreu um erro, recarregue a pagina e tente novamente');

                        }else if(response.error == "invalid_data"){
                            add_coupon_error.html('Ocorreu um erro, recarregue a pagina e tente novamente');

                        }else if(response.error == "not_found"){
                            add_coupon_error.html('Confira se você digitou corretamente');

                        }else if(response.error == "cart_not_valid"){
                            add_coupon_error.html('Cupom de desconto não aplicável');

                        }else if(response.error == "error_limit_use"){
                            add_coupon_error.html('Este cupom atingiu o limite de uso');

                        }else if(response.error == "error_max_value"){
                            add_coupon_error.html('O valor do carrinho deve ser menor que: '+response.max_value_formated+'');
                        }else if(response.error == "error_min_value"){
                            add_coupon_error.html('O valor do carrinho deve ser maior que: '+response.min_value_formated+'');
                        }else if(response.error == "error_expired"){
                            add_coupon_error.html('O cupom expirou');
                        }
                        
                        add_coupon_container.addClass('bp-form-error');
                        

                    }else if(response.success){

                        if(response.redirect && response.redirect == true){
                            location.href=response.redirect_url;
                        }else{

                            let description_json = JSON.parse(cart_description.val());

                            // console.log(coupon);
                            coupon.addClass('active');
                            coupon_name.html('<b>Cupom:</b> '+response.coupon_name);
                            coupon_value.html(response.coupon_value_formated);

                            total_value.html(response.cart_value_formated);
                            page_total_value.html(response.cart_value_formated);
                            
                            add_coupon_container.removeClass('bp-form-error');
                            add_coupon_error.html('');


                            load_shippings(response.shipping_list);

                            description_json.coupon = response.coupon_id;

                            cart_description.val(JSON.stringify(description_json));

                            cart_message_text.html('<p>Cupom adicionado ao carrinho!</p>');
                            cart_message.removeClass('error');
                            cart_message.removeClass('loading');
                            cart_message.addClass('active');
                            cart_message.data('time', 10);


                            let coupon_top = coupon.offset().top;
                            let header_height = $('.bp-header-section').innerHeight();
                            
                            $('html, body').animate({ 
                                scrollTop: (coupon_top - (header_height * 1.5)) - ($(window).innerHeight() * 0.1)
                            }, 800);

                        }

                        // console.log(response.dataLayerArgs);
                        // if(response.dataLayerArgs){
                        //     dataLayer.push(response.dataLayerArgs);
                        // }
                        
                    }else{
                        add_coupon_container.addClass('bp-form-error');
                        add_coupon_error.html('Ocorreu um erro, recarregue a pagina e tente novamente');
                        
                    }

                }
            });
        });

        add_coupon_input.change(function(event) {
            add_coupon_container.removeClass('bp-form-error');
            add_coupon_error.html('');
        });
    });


    $('.bp-shop-cart-section .address-container, .bp-checkout-section .address-container').each(function(index, el) {
        let shipping = $(el);
        let address_input = shipping.find('.address-input');
        let address_list = shipping.find('.address');
        let address_add_btn = shipping.find('.add-btn');
        let address_change_btn = shipping.find('.address-item .change');

        let shipping_options_list = $('.bp-shop-cart-section .shipping-options');
        let shipping_options = shipping_options_list.find('.bp-input-label .bp-input');

        let change_address_modal = $('.bp-change-address-modal');
        let change_address_modal_input = change_address_modal.find('.address-input');
        let change_address_modal_list = change_address_modal.find('.address');
        let change_address_modal_add_btn = change_address_modal.find('.add-btn');
        let change_address_modal_close = change_address_modal.find('.modal-close');

        let page_total_value = $('.bp-shop-cart-section .cart-total .total');

        let cart_description = $('.bp-shop-cart-section .cart-description');


        function load_addresses (event) {
            change_address_modal_list.html('<p class="center">Carregando</p>');

            let dados_envio = {
                'nonce': js_global.admin_nonce,
                'action': 'user_load_addresses',
            }


            $.ajax({
                url: js_global.xhr_url,
                type: 'POST',
                data: dados_envio,
                dataType: 'JSON',
                beforeSend: function(){
                    
                },
                complete: function(){
                    
                },
                error: function(erro){
                    // console.log(erro);
                    // alert('Erro!');
                    change_address_modal_list.html('<p class="center">Erro de comunicação com o servidor</p>');
                },
                success: function(response) {
                    // console.log('success');
                    // response = JSON.parse(response);
                    // console.log(response);

                    if(response.error){
                    
                        change_address_modal_list.html('<p class="center">Ocorreu um erro</p><p class="center">Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');

                    }else if(response.success){

                        if(response.redirect && response.redirect == true){
                            location.href=response.redirect_url;
                        }else{

                            change_address_modal_input.val(JSON.stringify(response.list));
                            change_address_modal_input.change();

                            // load_shippings(response.shipping_list);
                        }

                        
                    }else{
                        change_address_modal_list.html('<p class="center">Ocorreu um erro</p><p class="center">Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');
                    }

                }
            });
        }

        
        load_shippings();
        

        address_add_btn.click(load_addresses);

        address_input.change(function(event) {
            let json = null;
            
            if(address_input.val() != '' && isJson(address_input.val())){
                json = JSON.parse(address_input.val());

                if(json){

                    address_list.html(  
                                        '<div class="address-item">'
                                            +'<p class="name">'+json.name+' '+json.last_name+'</p>'
                                            +'<p class="company">'+json.company+'</p>'
                                            +'<div class="infos">'
                                                +'<p><b>Endereço:</b> <span>'+json.address+' - N° '+json.number+'</span></p>'
                                                +'<p><b>Complemento:</b> <span>'+json.complement+'</span></p>'
                                                +'<p><b>Bairro:</b> <span>'+json.district+'</span></p>'
                                                +'<p><b>Cidade:</b> <span>'+json.city+'</span></p>'
                                                +'<p><b>Estado:</b> <span>'+json.state+'</span></p>'
                                                +'<p><b>Cep:</b> <span>'+json.cep+'</span></p>'
                                            +'</div>'
                                            +'<button class="change" type="button" data-toggle="modal" data-target="#bp-cart-change-address-modal">Trocar</button>'
                                        +'</div>'
                                    );
                    address_add_btn.removeClass('active');
                }else{
                    address_list.html('');
                    address_add_btn.addClass('active');
                }

            }else{
                address_list.html('');
                address_add_btn.addClass('active');
            }


            address_change_btn = shipping.find('.address-item .change');

            address_change_btn.click(load_addresses);

            if(cart_description.length > 0){

                let description_json = JSON.parse(cart_description.val());
                
                description_json.address = json;

                cart_description.val(JSON.stringify(description_json));
            }


        });
        address_input.change();


        change_address_modal_input.change(function(event) {
            let json = change_address_modal_input.val();
            let html = '<p class="center">Nenhum endereço cadastrado</p>';
            
            if(isJson(json)){
                let list = JSON.parse(json);
                let class_default;

                if(list && list.length > 0){
                    html = '';

                    list.forEach( function(element, index) {
                        class_default = '';
                        if(element.default == true){
                            class_default = ' default ';
                        }
                        html += '<div class="address-item '+class_default+'" data-index="'+index+'">'
                                    +'<p class="name">'+element.name+' '+element.last_name+'</p>'
                                    +'<p class="company">'+element.company+'</p>'
                                    +'<div class="infos">'
                                        +'<p><b>Endereço:</b> <span>'+element.address+' - N° '+element.number+'</span></p>'
                                        +'<p><b>Complemento:</b> <span>'+element.complement+'</span></p>'
                                        +'<p><b>Bairro:</b> <span>'+element.district+'</span></p>'
                                        +'<p><b>Cidade:</b> <span>'+element.city+'</span></p>'
                                        +'<p><b>Estado:</b> <span>'+element.state+'</span></p>'
                                        +'<p><b>Cep:</b> <span>'+element.cep+'</span></p>'
                                    +'</div>'
                                +'</div>';
                    });

                    
                }else{
                    // change_address_modal_list.html('<p class="center">Nenhum endereço cadastrado</p>');
                }

            }else{
                // change_address_modal_list.html('<p class="center">Nenhum endereço cadastrado</p>');
            }

            change_address_modal_list.html(html);


            change_address_modal_list.find('.address-item').click(function(event) {
                let json = change_address_modal_input.val();
                
                if(isJson(json)){
                    let list = JSON.parse(json);
                    if(list && list.length > 0 && list[parseInt($(this).data('index'))]){

                        change_address_modal_list.html('<p class="center">Carregando</p>');

                        let dados_envio = {
                            'nonce': js_global.admin_nonce,
                            'action': 'user_select_address',
                            'selected': JSON.stringify( list[parseInt($(this).data('index'))]),
                        }

                        if(shipping.hasClass('-billing')){
                            dados_envio['action'] = 'user_select_address_billing';
                            dados_envio['order_id'] = shipping.data('order-id');
                        }


                        $.ajax({
                            url: js_global.xhr_url,
                            type: 'POST',
                            data: dados_envio,
                            dataType: 'JSON',
                            beforeSend: function(){
                                
                            },
                            complete: function(){
                                
                            },
                            error: function(erro){
                                // console.log(erro);
                                // alert('Erro!');
                                change_address_modal_list.html('<p class="center">Erro de comunicação com o servidor</p>');
                            },
                            success: function(response) {
                                // console.log('success');
                                // response = JSON.parse(response);
                                // console.log(response);

                                if(response.error){
                                
                                    change_address_modal_list.html('<p class="center">Ocorreu um erro</p><p class="center">Recarregue a pagina e tente novamente</p>');

                                }else if(response.success){

                                    if(response.redirect && response.redirect == true){
                                        location.href = response.redirect_url;
                                    }else{
                                        address_input.val(JSON.stringify(response.selected));
                                        address_input.change();
                                        change_address_modal_input.val(JSON.stringify(response.list));
                                        change_address_modal_input.change();

                                        load_shippings(response.shipping_list);

                                        page_total_value.html(response.cart_value_formated);

                                        change_address_modal.modal('hide');
                                    }

                                    
                                }else{
                                    change_address_modal_list.html('<p class="center">Ocorreu um erro</p><p class="center">Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe</p>');
                                }

                            }
                        });
                    }
                }
            });


            change_address_modal_add_btn.click(function(event) {
                $(change_address_modal_add_btn.data('target')).addClass('-ajax');
                $(change_address_modal_add_btn.data('target'))[0].form_input = address_input; 

                if(shipping.hasClass('-billing')){
                    $(change_address_modal_add_btn.data('target'))[0].billing = true; 
                    $(change_address_modal_add_btn.data('target'))[0].order_id = shipping.data('order-id'); 
                }
            });

        });
        change_address_modal_input.change();
    

        

    });

    
}(window.jQuery, window, document));